import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { SurveyForm } from '../../../../components/common/survey/form/SurveyForm';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store/useStore';
import { userSellTractorSurveySlice } from '../../../../store/userSellTractorSurveySlice';
import { SellTractorSurveyPageWrapper } from '../SellTractorSurveyPageWrapper';
import { SurveyInputHeader } from '../../../../components/common/survey/inputs/SurveyInputHeader';
import { SegmentButton, SegmentButtonGroup } from '../../../../components/common/buttons/SegmentButton';
import { TIRE_CONDITION_OPTIONS, TireConditionType } from '../../../../constants/product/product.constant';
import { sellTractorSurveySteps } from '../../../../constants/survey/sellTractorSurvey';

export const SellTractorSurveyTireConditionPage = () => {
  const navigate = useNavigate();
  const [frontTireCondition, setFrontTireCondition] = useState<TireConditionType | null>();
  const [rearTireCondition, setRearTireCondition] = useState<TireConditionType | null>();

  const dispatch = useAppDispatch();
  const userSellTractorSurveyActions = userSellTractorSurveySlice.actions;
  const userSellTractorSurveySelector = useAppSelector((state) => state.userSellTractorSurvey);

  const currentStep = sellTractorSurveySteps.STEP5;
  const steps = Object.keys(sellTractorSurveySteps);

  const handleFrontTireConditionToogle = (condition: TireConditionType) => {
    if (frontTireCondition === condition) {
      setFrontTireCondition(null);
    } else {
      setFrontTireCondition(condition);
    }
  };

  const handleRearTireConditionToogle = (condition: TireConditionType) => {
    if (rearTireCondition === condition) {
      setRearTireCondition(null);
    } else {
      setRearTireCondition(condition);
    }
  };

  useEffect(() => {
    const { frontTireCondition, rearTireCondition } = userSellTractorSurveySelector;
    setFrontTireCondition(frontTireCondition);
    setRearTireCondition(rearTireCondition);
  }, [userSellTractorSurveySelector.rearTireCondition, userSellTractorSurveySelector.frontTireCondition]);

  return (
    <>
      <SellTractorSurveyPageWrapper
        headerTitle={'타이어 상태를 알려주세요.'}
        canConfirm
        confirmHandler={() => {
          if (frontTireCondition) {
            dispatch(userSellTractorSurveyActions.changeFrontTireCondition(frontTireCondition));
          }

          if (rearTireCondition) {
            dispatch(userSellTractorSurveyActions.changeRearTireCondition(rearTireCondition));
          }

          navigate('/survey/progress/sell-tractor/hope-selling-price', { replace: true });
        }}
        prevButtonHandler={() => {
          navigate('/survey/progress/sell-tractor/extra-info-1', { replace: true });
        }}
        steps={steps}
        currentStep={currentStep}
      >
        <SurveyForm padding={'0px 16px'} gap={0}>
          <SurveyInputSection>
            <SurveyInputHeader inputTitle={'앞 타이어'} isOptional />

            <SegmentButtonGroup>
              {Object.entries(TIRE_CONDITION_OPTIONS).map(([key, condition]) => (
                <SegmentButton
                  key={`front-${key}`}
                  isSelected={frontTireCondition === condition}
                  onClick={() => handleFrontTireConditionToogle(condition)}
                >
                  {condition}
                </SegmentButton>
              ))}
            </SegmentButtonGroup>
          </SurveyInputSection>

          <SurveyInputSection>
            <SurveyInputHeader inputTitle={'뒷 타이어'} isOptional />
            <SegmentButtonGroup>
              {Object.entries(TIRE_CONDITION_OPTIONS).map(([key, condition]) => (
                <SegmentButton
                  key={`rear-${key}`}
                  isSelected={rearTireCondition === condition}
                  onClick={() => handleRearTireConditionToogle(condition)}
                >
                  {condition}
                </SegmentButton>
              ))}
            </SegmentButtonGroup>
          </SurveyInputSection>
        </SurveyForm>
      </SellTractorSurveyPageWrapper>
    </>
  );
};

const SurveyInputSection = styled.div`
  display: flex;
  padding-bottom: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;
